import { render, staticRenderFns } from "./AdminSubmissionForm.vue?vue&type=template&id=0ee7a6fa&scoped=true&"
import script from "./AdminSubmissionForm.vue?vue&type=script&lang=js&"
export * from "./AdminSubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubmissionForm.vue?vue&type=style&index=0&id=0ee7a6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7a6fa",
  null
  
)

export default component.exports